
import React, { FC } from 'react'
import { TextTableRow } from './TextTableRow'
import { SbEditableBlok } from '@storyblok/storyblok-editable'
import styled from 'styled-components'

export type TableDataProps = {
    TextTableRows: SbEditableBlok
}

export const TextTable: FC<{ blok: TableDataProps | any }> = ({ blok }) => {

    console.log('blok')
    console.log(blok)
    return (
        <StyledTable >
            <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', maxWidth: '612px', }}>
                {/* <thead>
                    <tr>
                        {tableData.columns.map((column, index) => (
                            <th key={index}>{column}</th>
                        ))}
                    </tr>
                </thead> */}
                <tbody>
                    {blok.TextTableRows.map((blok, index) => (
                        <TextTableRow blok={blok} />
                    ))}
                </tbody>
            </table>
        </StyledTable>
    )
}


const StyledTable = styled.table`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 12px;
    margin-left: 12px;
`
